import { render, staticRenderFns } from "./ReportManagement.vue?vue&type=template&id=30a6873b&scoped=true&"
import script from "./ReportManagement.vue?vue&type=script&lang=ts&"
export * from "./ReportManagement.vue?vue&type=script&lang=ts&"
import style0 from "./ReportManagement.vue?vue&type=style&index=0&id=30a6873b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a6873b",
  null
  
)

export default component.exports